import React from 'react'
import Advansedbannerr from "../components/img/Advansedbannerr.jpg";
const AdvancedAgeBanner = () => {
  return (
    <div>
    <div id="carouselExampleCaptions" className="carousel slide" data-bs-ride="carousel">
      <div className="carousel-inner">
        <div className="carousel-item active">
          <img src={Advansedbannerr} className="d-block w-100 carousel-image" alt="..." />
        </div>
      </div>
    </div>
  </div>
  )
}

export default AdvancedAgeBanner
